<div class="das-html-fragment-component" [innerHTML]="bypass(content.value)" contenteditable="false"></div>
